module.exports = __webpack_public_path__ + "static/media/shop_getty_mobile.0ecc66a6.jpg";